<template>
  <div>
    <div id="Modal-product-popup1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="modal fade">
      <div role="document" class="modal-dialog modal-dialog-centered" style="max-width: 1100px;">
        <div class="modal-content">
          <div class="modal-body py-5">
            <h2 class="font-weight-bold mb-5" v-if="infos.length!==2">{{infos[0]}}</h2>
            <p class="font-weight-bold" v-if="infos.length===2">infos[0]</p>
            <h4 class="font-weight-bold" v-if="infos.length===2">infos[1]</h4>
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-5 py-3">
                <img src="../assets/icon.png" alt="" />
              </div>
              <div class="col-lg-5 py-3 text-lg-left">
                <h5 class="mb-4">Fox HD Video Downloader</h5>
                <ul class="list-default mb-4 small">
                  <li>Download 1080P, HD, Full HD videos without any quality loss.</li>
                  <li>Download HD videos with 3X faster speed than other downloaders.</li>
                  <li>Download multiple HD videos with one click.</li>
                  <li>Download and convert HD videos for your devices directly.</li>
                  <li>Download and transfer HD videos to your devices easily.</li>
                </ul>
                <div class="text-center">
                  <a href="https://www.foxvideodownloader.com/download/index.html" class="btn btn-outline-primary m-2"><span class="h5 font-weight-bold mb-0">Download</span><i class="kv kv-mac h3 ml-2" style="vertical-align: -4px;"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//  Download 1080P &amp; 4K Videos without Quality Loss
//Download 320Kbps High-Quality Audio with One Click
//<p class="font-weight-bold">The link can't be analyzed, or it's prohibited to download.</p>
//<h4 class="font-weight-bold">But don’t worry, we have another powerful solution for you</h4>
export default {
  name: 'dialogs',
  props: ["infos"],
  data() {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs.vue